module.exports = class CategoriesListCtrl
  constructor: ->
    'ngInject'

  onDndMove: ($index) ->
    @categories.splice($index, 1)
    @onSort()
